import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges, OnInit, HostListener } from '@angular/core';
import { Column } from '../../models/column';
import { SortPipe } from '../../pipe/sort.pipe';
import { ValueField } from '../../models/valuefield';
import { MathFunction } from '../../models/mathfunction';
import { EventData } from '../../models/eventdata';
import { MDGFormulaSelectorComponent } from '../formula/mdg.formulaselector';
import { MDGFormulaComponent } from './mdg.formula';
import { MDGFormatComponent } from './mdg.format';
import { MDGSaveComponent } from './mdg.save';
import { PivotSave, ToolbarConfig } from '../../models/pivotsave';
import { HelperService } from '../../Services/Helper.Service';

@Component({
  selector: 'mdg-toolbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // templateUrl: 'MDG.Toolbar.html',
  template: `<div class='mdg-toolbar' [ngClass]='toolbarConfig.class'>
  <div class='mdg-config' [ngClass]='toolbarConfig.optionsConfig.class' *ngIf="pivotConfig.showOptions">
    <a (click)='showOption = !showOption' [class.disabled]='dataLoading' [title]="toolbarConfig.optionsConfig.title">
      <i [class]="toolbarConfig.optionsConfig.icon"></i>
      <span>{{toolbarConfig.optionsConfig.text}}</span>
    </a>
  </div>
  <div class='mdg-filter' [ngClass]='toolbarConfig.filterConfig.class' *ngIf="pivotConfig.showFilter">
    <a (click)='ShowFilter()' [class.disabled]='dataLoading' [title]="toolbarConfig.optionsConfig.title">
      <i [class]="toolbarConfig.filterConfig.icon"></i>
      <span>{{toolbarConfig.filterConfig.text}}</span>
    </a>
  </div>
  <div class='mdg-format' [ngClass]='toolbarConfig.formatConfig.class' *ngIf="pivotConfig.showFormat">
    <a (click)='ShowFormat()' [class.disabled]='dataLoading' [title]="toolbarConfig.optionsConfig.title">
      <i [class]="toolbarConfig.formatConfig.icon"></i>
      <span>{{toolbarConfig.formatConfig.text}}</span>
    </a>
  </div>
  <div class='mdg-export mdg-pivottype' [ngClass]='toolbarConfig.pivotTypeConfig.class' *ngIf="pivotConfig.showExport || pivotConfig.showPrint">
    <div class="dropdown">
      <div [class.disabled]='dataLoading'>
        <a class="dropdown-toggle" [class.disabled]='dataLoading' [title]='toolbarConfig.pivotTypeConfig.title'>
          <i class="fa fa-fw {{chartType.class}}"></i>
          <span>{{chartType.text}}</span>
        </a>
        <ul class="dropdown-menu no-radius">
          <li *ngFor="let ct of availChartTypes;">
            <a (click)='selectChart(ct)'>
              <i class='fa {{ct.class}}'></i> {{ct.text}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class='mdg-export' [ngClass]='toolbarConfig.exportConfig.class' *ngIf="pivotConfig.showExport || pivotConfig.showPrint">
    <div class="dropdown">
      <div [class.disabled]='dataLoading'>
        <a class="dropdown-toggle" [class.disabled]='dataLoading' [title]='toolbarConfig.exportConfig.title'>
          <i [class]="toolbarConfig.exportConfig.icon"></i>
          <span>{{toolbarConfig.exportConfig.text}}</span>
        </a>
        <ul class="dropdown-menu no-radius">
          <li *ngIf="pivotConfig.showExport && chartType.value === 'grid'">
            <a (click)='exportPivot("XLS")'>
              <i class='fa fa-file-excel-o'></i> Excel</a>
          </li>
          <li *ngIf="pivotConfig.showExport && chartType.value !== 'grid'">
            <a (click)='exportPivot("IMG")'>
              <i class='fa fa-file-image-o'></i> Image</a>
          </li>
          <li *ngIf="pivotConfig.showExport">
            <a (click)='exportPivot("PDF")'>
              <i class='fa fa-file-pdf-o'></i> PDF</a>
          </li>
          <li *ngIf="pivotConfig.showPrint">
            <a (click)='exportPivot("PRINT")'>
              <i class='fa fa-print'></i> Print</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class='mdg-save' [ngClass]='toolbarConfig.saveConfig.class' *ngIf="pivotConfig.showSave">
    <a (click)='SavePivot()' [class.disabled]='dataLoading' [title]="toolbarConfig.saveConfig.title">
      <i [class]="toolbarConfig.saveConfig.icon"></i>
      <span>{{toolbarConfig.saveConfig.text}}</span>
    </a>
  </div>
  <div class='mdg-fullscreen' [ngClass]='toolbarConfig.fullscreenConfig.class' >
    <a (click)='ShowFullScreen()' *ngIf="!isFSRequested" [class.disabled]='dataLoading' [title]="toolbarConfig.fullscreenConfig.title">
      <i [class]="toolbarConfig.fullscreenConfig.icon"></i>
      <span>{{toolbarConfig.fullscreenConfig.text}}</span>
    </a>
    <a (click)='RestoreFullScreen()' *ngIf="isFSRequested" [class.disabled]='dataLoading' [title]="toolbarConfig.fullscreenConfig.closeTitle">
      <i [class]="toolbarConfig.fullscreenConfig.closeIcon"></i>
      <span>{{toolbarConfig.fullscreenConfig.text}}</span>
    </a>
  </div>
</div>
<div *ngIf="showOption" class='mdg-options-container'>
  <div class="mdg-options-popup-container">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
            <h3>
              <i class="fa fa-fw fa-table"></i> Configure Pivot fields</h3>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6 text-lg-right text-md-right text-sm-right">
            <small>Drag & Drop fields to configure your pivot report.</small>
          </div>
        </div>
        <hr class="buffer-5-0">
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content">
        <div class='row'>
          <div class='col-md-3 col-sm-3 col-xs-12'>
            <div class='border-top-ddd border-left-ddd border-right-ddd'>
              <div class="padding-5 bg-f7f7f7" *ngIf="showColSearch">
                <input class="mdg-toolbar-search-input" [(ngModel)]='searchText' (keyup)='onColSearch()' (keydown)='onColSearch()' placeholder="Search Fields...">
                <div class="pull-right right-buffer-5">
                  <i class='fa fa-times cursor-pointer' (click)='showColSearch = !showColSearch; searchText = ""; onColSearch()'></i>
                </div>
              </div>
              <div *ngIf="!showColSearch" class="padding-5 bg-f7f7f7">List of Fields
                <div class="pull-right right-buffer-5">
                  <i class='fa fa-search cursor-pointer padding-right-5' (click)='showColSearch = !showColSearch'></i>
                  <i class='fa cursor-pointer' (click)='checkSelection()' [class.fa-check-square-o]='selectAll' [class.padding-right-2]='!selectAll'
                    [class.fa-square-o]='!selectAll'></i>
                </div>
              </div>
            </div>
            <div class="mdg-options-stack-container overflow-y border-ddd" dnd-droppable (onDropSuccess)="onDropped($event)">
              <div class="border-bottom-ddd padding-5" dnd-draggable *ngFor="let col of scolumns" [dragData]="col" [class.text-bold]='col.checked' title="{{col.displayName}}">
                <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
                <div class="pull-right">
                  <i class='fa cursor-pointer' (click)='selectCheck(col)' [class.fa-check-square-o]='col.checked' [class.padding-right-2]='!col.checked'
                    [class.fa-square-o]='!col.checked'></i>
                </div>
              </div>
              <div class='border-bottom-ddd'>
                <div class="padding-5 bg-f7f7f7" *ngIf="formulaFields.length > 0">Formula Fields</div>
              </div>
              <div class="border-bottom-ddd padding-5" dnd-draggable *ngFor="let col of formulaFields" [dragData]="col" title="{{col.displayName}}">
                <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
                <div class="pull-right">
                  <i class='fa cursor-pointer fa-pencil' (click)='editFormula(col)'></i>
                </div>
              </div>
            </div>
          </div>
          <div class='col-md-3 col-sm-3 col-xs-12'>
            <div class='border-top-ddd border-left-ddd border-right-ddd'>
              <div class="padding-5 bg-f7f7f7">Columns
                <div class="pull-right cursor-pointer mouse-over-000" title='Move Down'>
                  <i class='fa fa-arrow-down text-999 mouse-over-000' (click)='colMoveDown()'></i>
                </div>
                <div class="pull-right cursor-pointer right-buffer-10 mouse-over-000" title='Move Up'>
                  <i class='fa fa-arrow-up text-999 mouse-over-000' (click)='colMoveUp()'></i>
                </div>
              </div>
            </div>
            <div class="mdg-options-stack-container overflow-y border-ddd" dnd-droppable (onDropSuccess)="onColDropped($event)">
              <div class="border-bottom-ddd padding-5" [class.mdg-selected]='col.selected' dnd-draggable [dragData]="col" *ngFor="let col of selectedColumns"
                (click)='selectColItem(col)' title="{{col.displayName}}">
                <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
                <!-- <div class="pull-right">{{col.colOrder}}</div> -->
              </div>
            </div>
          </div>
          <div class='col-md-3 col-sm-3 col-xs-12'>
            <div class='border-top-ddd border-left-ddd border-right-ddd'>
              <div class="padding-5 bg-f7f7f7">Rows
                <div class="pull-right cursor-pointer mouse-over-000" title='Move Down'>
                  <i class='fa fa-arrow-down text-999 mouse-over-000' (click)='rowMoveDown()'></i>
                </div>
                <div class="pull-right cursor-pointer right-buffer-10 mouse-over-000" title='Move Up'>
                  <i class='fa fa-arrow-up text-999 mouse-over-000' (click)='rowMoveUp()'></i>
                </div>
              </div>
            </div>
            <div class="mdg-options-stack-container overflow-y border-ddd" dnd-droppable (onDropSuccess)="onRowDropped($event)">
              <div class="border-bottom-ddd padding-5" [class.mdg-selected]='col.selected' dnd-draggable [dragData]="col" *ngFor="let col of selectedRows"
                (click)='selectRowItem(col)' title="{{col.displayName}}">
                <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
                <!-- <div class="pull-right">{{col.colOrder}}</div> -->
              </div>
            </div>
          </div>
          <div class='col-md-3 col-sm-3 col-xs-12'>
            <div class='border-top-ddd border-left-ddd border-right-ddd'>
              <div class="padding-5 bg-f7f7f7">Values
                <div class="pull-right cursor-pointer mouse-over-000" title='Move Down'>
                  <i class='fa fa-arrow-down text-999 mouse-over-000' (click)='valMoveDown()'></i>
                </div>
                <div class="pull-right cursor-pointer right-buffer-10 mouse-over-000" title='Move Up'>
                  <i class='fa fa-arrow-up text-999 mouse-over-000' (click)='valMoveUp()'></i>
                </div>
              </div>
            </div>
            <div class="mdg-options-stack-container overflow-y border-ddd" dnd-droppable (onDropSuccess)="onValDropped($event)">
              <div class="border-bottom-ddd padding-5 formulae" [class.mdg-selected]='col.column.selected' dnd-draggable [dragData]="col"
                *ngFor="let col of selectedValues" title="{{col.column.valueField ? col.column.displayName : col.mathFn.Name + ' of ' + col.column.displayName}}">
                <div class='fcontent' (click)='selectValItem(col)'>{{col.column.valueField ? col.column.displayName : col.mathFn.Name + " of " + col.column.displayName}}</div>
                <!-- <div class="pull-right">{{col.colOrder}}</div> -->
                <div *ngIf="!col.column.valueField" class="option" (click)='showFormula(col)'>
                  <span>fx</span>
                  <i class='fa fa-angle-down cursor-pointer'></i>
                  <!-- <div class="dropdown-content">
                    <a *ngFor="let item of col.mathFns" (click)='selectFn(col,item,$event)'>{{item.Name}}</a>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-md-6 col-sm-6 hidden-xs col-lg-6">
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-success right-buffer-10' (click)='AddFField()'>Add Formula Field</button>
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='ApplyChanges()'>Apply</button>
            <button class='btn btn-sm btn-default' (click)='cancelOptions()'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="showFilter" class='mdg-options-container'>
  <div class="mdg-options-popup-container filter">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
            <h3>
              <i class="fa fa-fw fa-filter"></i> Configure Pivot Extra Filters</h3>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6 text-lg-right text-md-right text-sm-right">
            <small>Drag & Drop fields to add filters to your pivot report.</small>
          </div>
        </div>
        <hr class="buffer-5-0">
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content">
        <div class='row'>
          <div class='col-md-6 col-sm-6 col-xs-12'>
            <div class='border-top-ddd border-left-ddd border-right-ddd'>
              <div class="padding-5 bg-f7f7f7" *ngIf="showCFilterSearch">
                <input class="mdg-toolbar-search-input" [(ngModel)]='searchCFilterText' (keyup)='onCFilterSearch()' (keydown)='onCFilterSearch()' placeholder="Search Fields...">
                <div class="pull-right right-buffer-5">
                  <i class='fa fa-times cursor-pointer' (click)='showCFilterSearch = !showCFilterSearch; searchCFilterText = ""; onCFilterSearch()'></i>
                </div>
              </div>
              <div *ngIf="!showCFilterSearch" class="padding-5 bg-f7f7f7">List of Fields
                <div class="pull-right right-buffer-5">
                  <i class='fa fa-search cursor-pointer padding-right-5' (click)='showCFilterSearch = !showCFilterSearch'></i>
                  <i class='fa cursor-pointer' (click)='checkFSelection()' [class.fa-check-square-o]='selectFAll' [class.padding-right-2]='!selectFAll'
                    [class.fa-square-o]='!selectFAll'></i>
                </div>
              </div>
            </div>
            <div class="mdg-options-stack-container overflow-y border-ddd" dnd-droppable (onDropSuccess)="onFDropped($event)">
              <div class="border-bottom-ddd padding-5" dnd-draggable *ngFor="let col of fcolumns" [dragData]="col" [class.text-bold]='col.checked' title="{{col.displayName}}">
                <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
                <div class="pull-right">
                  <i class='fa cursor-pointer' (click)='selectFCheck(col)' [class.fa-check-square-o]='col.checked' [class.padding-right-2]='!col.checked'
                    [class.fa-square-o]='!col.checked'></i>
                </div>
              </div>
            </div>
          </div>
          <div class='col-md-6 col-sm-6 col-xs-12'>
            <div class='border-top-ddd border-left-ddd border-right-ddd'>
              <div class="padding-5 bg-f7f7f7">Filters
              </div>
            </div>
            <div class="mdg-options-stack-container overflow-y border-ddd" dnd-droppable (onDropSuccess)="onFColDropped($event)">
              <div class="border-bottom-ddd padding-5" [class.mdg-selected]='col.selected' dnd-draggable [dragData]="col" *ngFor="let col of selectedFColumns"
                (click)='selectColItem(col)'>
                <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
                <!-- <div class="pull-right">{{col.colOrder}}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-md-6 col-sm-6 hidden-xs col-lg-6">
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='ApplyFilter()'>Apply</button>
            <button class='btn btn-sm btn-default' (click)='cancelFilter();'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<mdg-formulaselector #formulaselector (updateFormula)='onFSUpdateFormula($event)'></mdg-formulaselector>
<mdg-formula #formula [columns]='columns' [formulas]='formulas' (updateFormula)='onUpdateFormula($event)' (errorFormula)='onErrorFormula($event)'></mdg-formula>
<mdg-format #format (updateFormat)='onUpdateFormat($event)' (error)='onSaveError($event)'></mdg-format>
<mdg-save #save (saveReport)='onSaveReport($event)' (saveError)='onSaveError($event)'></mdg-save>
`
})
export class MDGToolBarComponent implements OnChanges, OnInit {
  @Input() fcolumns: Column[] = [];
  @Input() formulas: MathFunction[] = [];
  @Input() dataLoading: boolean = true;
  @Input() isFullScreen: boolean = false;
  @Input() isCustomSave: boolean = false;
  @Input() isSaveSubscribed: boolean = false;
  @Input() pivotConfig: PivotSave;
  @Input() toolbarConfig: ToolbarConfig = new ToolbarConfig();

  @Output() applyChanges: EventEmitter<EventData> = new EventEmitter<EventData>();
  @Output() exportReport: EventEmitter<String> = new EventEmitter<String>();
  @Output() showFullScreen: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Output() updateFormat: EventEmitter<EventData> = new EventEmitter<EventData>();
  @Output() saveReport: EventEmitter<any> = new EventEmitter<any>();
  @Output() error: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeChartType: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('formulaselector') formulaselector: MDGFormulaSelectorComponent;
  @ViewChild('formula') formula: MDGFormulaComponent;
  @ViewChild('format') format: MDGFormatComponent;
  @ViewChild('save') save: MDGSaveComponent;

  columns: Column[] = [];
  scolumns: Column[] = [];
  selectedColumns: Column[] = [];
  selectedFColumns: Column[] = [];
  selectedRows: Column[] = [];
  selectedValues: ValueField[] = [];
  formulaFields: Column[] = [];

  selectedColumnsB: Column[] = [];
  selectedFColumnsB: Column[] = [];
  selectedRowsB: Column[] = [];
  selectedValuesB: ValueField[] = [];
  formulaFieldsB: Column[] = [];

  selectedValue: ValueField;
  selectedFormulaField: Column;
  showOption: boolean = false;
  showFilter: boolean = false;
  selectAll: boolean = false;
  selectFAll: boolean = false;
  isFSRequested: boolean = false;

  showColSearch: boolean = false;
  searchText: string = '';

  showCFilterSearch: boolean = false;
  searchCFilterText: string = '';

  chartTypes: any[] = [{ value: 'grid', text: 'Grid', class: 'fa-table' },
  { value: 'line', text: 'Line Chart', class: 'fa-line-chart ' },
  { value: 'bar', text: 'Bar Chart', class: 'fa-bar-chart' },
  { value: 'doughnut', text: 'Doughnut Chart', class: 'fa-pie-chart ' },
  { value: 'radar', text: 'Radar Chart', class: 'fa-pie-chart ' },
  { value: 'pie', text: 'Pie Chart', class: 'fa-pie-chart ' },
  { value: 'polarArea', text: 'Polar Area Chart', class: 'fa-pie-chart ' }];

  availChartTypes: any[] = [{ value: 'grid', text: 'Grid', class: 'fa-table' }];

  chartType: any = this.chartTypes[0];

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showOption && !this.formulaselector.showFormula && !this.formula.showFormula) {
      this.showOption = false;
    }
    if (this.showFilter) {
      this.showFilter = false;
    }
  }

  constructor(private helper: HelperService, private sort: SortPipe) { }

  ngOnInit() {
    if (this.pivotConfig && this.pivotConfig.reportType && this.pivotConfig.reportType !== null && this.pivotConfig.reportType.trim() !== '' && this.chartTypes.filter(f => f.value === this.pivotConfig.reportType).length > 0) {
      this.chartType = this.chartTypes.filter(f => f.value === this.pivotConfig.reportType)[0];
      this.changeChartType.emit(this.chartType);
      this.assignChartTypes();
    }
  }

  ngOnChanges(change: SimpleChanges) {
    if (change.isFullScreen !== undefined && change.isFullScreen.currentValue !== change.isFullScreen.previousValue) {
      this.isFSRequested = change.isFullScreen.currentValue;
    }
  }

  assignChartTypes() {
    this.availChartTypes = this.chartTypes.filter(f => {
      if (f.value === 'grid') {
        return true;
      }
      if (f.value === 'line') {
        return this.pivotConfig.lineChart;
      }
      if (f.value === 'bar') {
        return this.pivotConfig.barChart;
      }
      if (f.value === 'doughnut') {
        return this.pivotConfig.doughnutChart;
      }
      if (f.value === 'radar') {
        return this.pivotConfig.radarChart;
      }
      if (f.value === 'pie') {
        return this.pivotConfig.pieChart;
      }
      if (f.value === 'polarArea') {
        return this.pivotConfig.polarAreaChart;
      }
      return false;
    });
  }

  setChart(chartName: string) {
    const chart = this.chartTypes.filter(f => f.value === chartName);
    if (chart.length) {
      this.selectChart(chart[0]);
      this.assignChartTypes();
    }
  }

  selectChart(chart: any) {
    this.chartType = chart;
    this.changeChartType.emit(this.chartType);
  }

  assignColumnSelection() {
    this.columns.forEach(col => {
      const sCol = this.selectedColumns.filter(f => f.colName === col.colName);
      if (sCol.length > 0) {
        col.checked = true;
      }
      const sRow = this.selectedRows.filter(f => f.colName === col.colName);
      if (sRow.length > 0) {
        col.checked = true;
      }
      const sVal = this.selectedValues.filter(f => f.column.colName === col.colName);
      if (sVal.length > 0) {
        col.checked = true;
      }
    });
  }

  selectCheck(col: Column) {
    col.checked = !col.checked;
    if (col.checked) {
      if (col.dataType === 'number' && this.selectedValues.filter(f => f.column.colName === col.colName).length === 0) {
        const obj = new ValueField();
        obj.column = col;
        obj.column.colOrder = Math.max(...this.selectedValues.map(f => f.column.colOrder)) + 1;
        obj.mathFn = this.formulas.filter(f => f.Name === 'Sum')[0];
        obj.mathFns = this.formulas;
        this.selectedValues.push(obj);
      } else if (col.dataType !== 'number' && this.selectedRows.filter(f => f.colName === col.colName).length === 0) {
        const obj = Object.assign({}, col);
        obj.colOrder = Math.max(...this.selectedRows.map(f => f.colOrder)) + 1;
        this.selectedRows.push(obj);
      }
    }
    if (!col.checked && this.selectedRows.filter(f => f.colName === col.colName).length > 0) {
      this.selectedRows = this.selectedRows.filter(f => f.colName !== col.colName);
    }
    if (!col.checked && this.selectedColumns.filter(f => f.colName === col.colName).length > 0) {
      this.selectedColumns = this.selectedColumns.filter(f => f.colName !== col.colName);
    }
    if (!col.checked && this.selectedValues.filter(f => f.column.colName === col.colName).length > 0) {
      this.selectedValues = this.selectedValues.filter(f => f.column.colName !== col.colName);
    }
    this.selectAll = this.columns.filter(f => f.checked).length === this.columns.length;
    this.assignOrder(this.selectedColumns);
    this.assignOrder(this.selectedRows);
    this.assignValOrder(this.selectedValues);
  }

  setData(columns: Column[], cols: Column[], rows: Column[], values: ValueField[], formulas: Column[], filters: Column[]) {
    this.columns = columns;
    this.scolumns = columns;
    this.selectedColumns = cols;
    this.selectedRows = rows;
    this.selectedValues = values;
    this.formulaFields = formulas;
    this.selectedFColumns = filters;
    this.selectedColumnsB = this.helper.copyArray(cols);
    this.selectedRowsB = this.helper.copyArray(rows);
    this.selectedValuesB = this.helper.copyArray(values);
    this.formulaFieldsB = this.helper.copyArray(formulas);
    this.selectedFColumnsB = this.helper.copyArray(filters);
    this.assignColumnSelection();
  }

  onColSearch() {
    setTimeout(() => {
      if (this.searchText !== undefined && this.searchText !== null && this.searchText !== '') {
        this.scolumns = this.columns.filter(f => f.displayName.toLowerCase().includes(this.searchText.toString().toLowerCase()));
      } else {
        this.scolumns = this.columns;
      }
    }, 50);
  }

  onCFilterSearch() {
    setTimeout(() => {
      if (this.searchCFilterText !== undefined && this.searchCFilterText !== null && this.searchCFilterText !== '') {
        this.fcolumns = this.helper.copyArray(this.columns.filter(f => this.selectedColumns.filter(c => c.colName === f.colName).length === 0 && this.selectedRows.filter(c => c.colName === f.colName).length === 0 && this.selectedValues.filter(c => c.column.colName === f.colName).length === 0)).filter(f => f.displayName && f.displayName != null ? f.displayName.toLowerCase().includes(this.searchCFilterText.toString().toLowerCase()) : false);
      } else {
        this.fcolumns = this.helper.copyArray(this.columns.filter(f => this.selectedColumns.filter(c => c.colName === f.colName).length === 0 && this.selectedRows.filter(c => c.colName === f.colName).length === 0 && this.selectedValues.filter(c => c.column.colName === f.colName).length === 0));
      }
    }, 50);
  }

  checkSelection() {
    this.selectAll = !this.selectAll;
    this.columns.forEach(col => {
      col.checked = this.selectAll;
    });
    if (this.selectAll) {
      const cols = this.selectedColumns.map(f => f.colName);
      const rows = this.selectedRows.map(f => f.colName);
      const vals = this.selectedValues.map(f => f.column.colName);
      const unselected = this.columns.filter(f => !cols.includes(f.colName) && !rows.includes(f.colName) && !vals.includes(f.colName));
      unselected.forEach(col => {
        col.colOrder = Math.max(...this.selectedRows.map(f => f.colOrder)) + 1;
        this.selectedRows.push(col);
      });
    } else {
      this.selectedColumns = [];
      this.selectedRows = [];
      this.selectedValues = [];
    }
  }

  assignOrder(cols: Column[]) {
    cols = this.sort.transform(cols, 'colOrder');
    let i = 0;
    cols.forEach(col => {
      i++;
      col.colOrder = i;
    });
  }

  assignValOrder(cols: ValueField[]) {
    cols = this.sort.transformValues(cols, 'colOrder');
    let i = 0;
    cols.forEach(col => {
      i++;
      col.column.colOrder = i;
    });
  }

  onDropped(col: any) {
    if (col.dragData['column'] === undefined) {
      if (this.selectedRows && this.selectedRows.filter(f => f.colName === col.dragData.colName).length > 0) {
        this.selectedRows = this.selectedRows.filter(f => f.colName !== col.dragData.colName);
      }
      if (this.selectedColumns && this.selectedColumns.filter(f => f.colName === col.dragData.colName).length > 0) {
        this.selectedColumns = this.selectedColumns.filter(f => f.colName !== col.dragData.colName);
      }
      this.checkColumnSelected(col.dragData.colName);
    } else {
      if (this.selectedValues && this.selectedValues.filter(f => f.column.colName === col.dragData.column.colName).length > 0) {
        this.selectedValues = this.selectedValues.filter(f => f.column.colName !== col.dragData.column.colName);
      }
      this.checkColumnSelected(col.dragData.column.colName);
    }
  }

  checkColumnSelected(colName: any) {
    let exists = false;
    if (this.selectedColumns.filter(f => f.colName === colName).length > 0) {
      exists = true;
    }
    if (this.selectedRows.filter(f => f.colName === colName).length > 0) {
      exists = true;
    }
    if (this.selectedValues.filter(f => f.column.colName === colName).length > 0) {
      exists = true;
    }
    const selectedItem = this.columns.filter(f => f.colName === colName);
    if (selectedItem.length > 0) {
      selectedItem[0].checked = exists;
    }
  }

  onColDropped(col: any) {
    if (col.dragData['column'] !== undefined) {
      col.dragData = col.dragData.column;
      if (!col.dragData.valueField) {
        if (this.selectedValues && this.selectedValues.filter(f => f.column.colName === col.dragData.colName).length > 0) {
          this.selectedValues = this.selectedValues.filter(f => f.column.colName !== col.dragData.colName);
        }
      }
    }
    if (!col.dragData.valueField) {
      col.dragData.selected = false;
      if (this.selectedRows && this.selectedRows.filter(f => f.colName === col.dragData.colName).length > 0) {
        this.selectedRows = this.selectedRows.filter(f => f.colName !== col.dragData.colName);
      }
      if (this.selectedColumns.filter(f => f.colName === col.dragData.colName).length === 0) {
        col.dragData.colOrder = Math.max(...this.selectedColumns.map(f => f.colOrder)) + 1;
        this.selectedColumns.push(col.dragData);
      }
      this.assignOrder(this.selectedColumns);
      this.assignOrder(this.selectedRows);
      this.checkColumnSelected(col.dragData.colName);
    }
  }

  onRowDropped(col: any) {
    if (col.dragData['column'] !== undefined) {
      col.dragData = col.dragData.column;
      if (!col.dragData.valueField) {
        if (this.selectedValues && this.selectedValues.filter(f => f.column.colName === col.dragData.colName).length > 0) {
          this.selectedValues = this.selectedValues.filter(f => f.column.colName !== col.dragData.colName);
        }
      }
    }
    if (!col.dragData.valueField) {
      col.dragData.selected = false;
      if (this.selectedColumns && this.selectedColumns.filter(f => f.colName === col.dragData.colName).length > 0) {
        this.selectedColumns = this.selectedColumns.filter(f => f.colName !== col.dragData.colName);
      }
      if (this.selectedRows.filter(f => f.colName === col.dragData.colName).length === 0) {
        col.dragData.colOrder = Math.max(...this.selectedRows.map(f => f.colOrder)) + 1;
        this.selectedRows.push(col.dragData);
      }
      this.assignOrder(this.selectedColumns);
      this.assignOrder(this.selectedRows);
      this.checkColumnSelected(col.dragData.colName);
    }
  }

  selectColItem(col: Column) {
    col.selected = !col.selected;
    this.selectedColumns.filter(f => f.colName !== col.colName).forEach(column => {
      column.selected = false;
    });
  }

  colMoveUp() {
    const selCol = this.selectedColumns.filter(f => f.selected === true);
    if (selCol.length > 0) {
      const preCol = this.selectedColumns.filter(f => f.colOrder === (selCol[0].colOrder - 1));
      if (preCol !== undefined && preCol.length > 0) {
        preCol[0].colOrder = selCol[0].colOrder;
        selCol[0].colOrder = selCol[0].colOrder - 1;
        // setTimeout(() => {
        //   selCol[0].selected = false;
        // }, 1000);
      }
      this.selectedColumns = this.sort.transform(this.selectedColumns, 'colOrder');
    }
  }

  colMoveDown() {
    const selCol = this.selectedColumns.filter(f => f.selected === true);
    if (selCol.length > 0) {
      const nxtCol = this.selectedColumns.filter(f => f.colOrder === (selCol[0].colOrder + 1));
      if (nxtCol !== undefined && nxtCol.length > 0) {
        nxtCol[0].colOrder = selCol[0].colOrder;
        selCol[0].colOrder = selCol[0].colOrder + 1;
        // setTimeout(() => {
        //   selCol[0].selected = false;
        // }, 1000);
      }
      this.selectedColumns = this.sort.transform(this.selectedColumns, 'colOrder');
    }
  }

  selectRowItem(col: Column) {
    col.selected = !col.selected;
    this.selectedRows.filter(f => f.colName !== col.colName).forEach(column => {
      column.selected = false;
    });
  }

  rowMoveUp() {
    const selRow = this.selectedRows.filter(f => f.selected === true);
    if (selRow.length > 0) {
      const preCol = this.selectedRows.filter(f => f.colOrder === (selRow[0].colOrder - 1));
      if (preCol !== undefined && preCol.length > 0) {
        preCol[0].colOrder = selRow[0].colOrder;
        selRow[0].colOrder = selRow[0].colOrder - 1;
        // setTimeout(() => {
        //   selRow[0].selected = false;
        // }, 1000);
      }
      this.selectedRows = this.sort.transform(this.selectedRows, 'colOrder');
    }
  }

  rowMoveDown() {
    const selRow = this.selectedRows.filter(f => f.selected === true);
    if (selRow.length > 0) {
      const nxtCol = this.selectedRows.filter(f => f.colOrder === (selRow[0].colOrder + 1));
      if (nxtCol !== undefined && nxtCol.length > 0) {
        nxtCol[0].colOrder = selRow[0].colOrder;
        selRow[0].colOrder = selRow[0].colOrder + 1;
        // setTimeout(() => {
        //   selRow[0].selected = false;
        // }, 1000);
      }
      this.selectedRows = this.sort.transform(this.selectedRows, 'colOrder');
    }
  }

  onValDropped(col: any) {
    if (col.dragData['column'] !== undefined) {
      col.dragData = col.dragData.column;
      if (this.selectedValues && this.selectedValues.filter(f => f.column.colName === col.dragData.colName).length > 0) {
        this.selectedValues = this.selectedValues.filter(f => f.column.colName !== col.dragData.colName);
      }
    }
    col.dragData.selected = false;
    if (this.selectedRows && this.selectedRows.filter(f => f.colName === col.dragData.colName).length > 0) {
      this.selectedRows = this.selectedRows.filter(f => f.colName !== col.dragData.colName);
    }
    if (this.selectedColumns && this.selectedColumns.filter(f => f.colName === col.dragData.colName).length > 0) {
      this.selectedColumns = this.selectedColumns.filter(f => f.colName !== col.dragData.colName);
    }
    if (this.selectedValues.filter(f => f.column.colName === col.dragData.colName).length === 0) {
      col.dragData.colOrder = Math.max(...this.selectedValues.map(f => f.column.colOrder)) + 1;
      const obj = new ValueField();
      obj.column = col.dragData;
      if (obj.column.dataType === 'number') {
        obj.mathFn = this.formulas.filter(f => f.Name === 'Sum')[0];
        obj.mathFns = this.formulas;
      } else if (obj.column.dataType === 'date') {
        obj.mathFn = this.formulas.filter(f => f.Name === 'Min')[0];
        obj.mathFns = this.formulas.filter(f => f.Name === 'Count' || f.Name === 'Distinct Count' || f.Name === 'Min' || f.Name === 'Max');
      } else {
        obj.mathFn = this.formulas.filter(f => f.Name === 'Count')[0];
        obj.mathFns = this.formulas.filter(f => f.Name === 'Count' || f.Name === 'Distinct Count');
      }
      this.selectedValues.push(obj);
    }
    this.assignValOrder(this.selectedValues);
    this.checkColumnSelected(col.dragData.colName);
  }

  selectValItem(col: ValueField) {
    col.column.selected = !col.column.selected;
    this.selectedValues.filter(f => f.column.colName !== col.column.colName).forEach(column => {
      column.column.selected = false;
    });
  }

  valMoveUp() {
    const selRow = this.selectedValues.filter(f => f.column.selected === true);
    if (selRow.length > 0) {
      const preCol = this.selectedValues.filter(f => f.column.colOrder === (selRow[0].column.colOrder - 1));
      if (preCol !== undefined && preCol.length > 0) {
        preCol[0].column.colOrder = selRow[0].column.colOrder;
        selRow[0].column.colOrder = selRow[0].column.colOrder - 1;
        // setTimeout(() => {
        //   selRow[0].column.selected = false;
        // }, 1000);
      }
      this.selectedValues = this.sort.transformValues(this.selectedValues, 'colOrder');
    }
  }

  valMoveDown() {
    const selRow = this.selectedValues.filter(f => f.column.selected === true);
    if (selRow.length > 0) {
      const nxtCol = this.selectedValues.filter(f => f.column.colOrder === (selRow[0].column.colOrder + 1));
      if (nxtCol !== undefined && nxtCol.length > 0) {
        nxtCol[0].column.colOrder = selRow[0].column.colOrder;
        selRow[0].column.colOrder = selRow[0].column.colOrder + 1;
        // setTimeout(() => {
        //   selRow[0].column.selected = false;
        // }, 1000);
      }
      this.selectedValues = this.sort.transformValues(this.selectedValues, 'colOrder');
    }
  }

  selectFn(col: ValueField, fn: MathFunction, e: Event) {
    col.mathFn = fn;
    col.column.selected = false;
    e.preventDefault();
    e.stopPropagation();
  }

  ApplyChanges() {
    const obj = new EventData();
    this.showOption = false;
    obj.Columns = this.helper.copyArray(this.selectedColumns);
    obj.Rows = this.helper.copyArray(this.selectedRows);
    obj.Values = this.helper.copyArray(this.selectedValues);
    obj.Filters = this.helper.copyArray(this.selectedFColumns);
    obj.Fields = this.helper.copyArray(this.formulaFields);

    this.selectedColumnsB = this.helper.copyArray(this.selectedColumns);
    this.selectedRowsB = this.helper.copyArray(this.selectedRows);
    this.selectedValuesB = this.helper.copyArray(this.selectedValues);
    this.selectedFColumnsB = this.helper.copyArray(this.selectedFColumns);
    this.formulaFieldsB = this.helper.copyArray(this.formulaFields);
    setTimeout(() => {
      this.applyChanges.emit(obj);
    }, 0);
  }

  cancelOptions() {
    this.selectedColumns = this.helper.copyArray(this.selectedColumnsB);
    this.selectedRows = this.helper.copyArray(this.selectedRowsB);
    this.selectedValues = this.helper.copyArray(this.selectedValuesB);
    this.formulaFields = this.helper.copyArray(this.formulaFieldsB);
    this.selectedFColumns = this.helper.copyArray(this.selectedFColumnsB);
    this.showOption = false;
    setTimeout(() => {
      this.checkSelectedColumns();
    }, 10);
  }

  checkSelectedColumns() {
    this.scolumns.forEach(col => {
      col.checked = false;
      if (this.selectedColumns.filter(f => f.colName === col.colName).length > 0) {
        col.checked = true;
      }
      if (this.selectedRows.filter(f => f.colName === col.colName).length > 0) {
        col.checked = true;
      }
      if (this.selectedValues.filter(f => f.column.colName === col.colName).length > 0) {
        col.checked = true;
      }
    });
    this.selectAll = this.scolumns.length === this.scolumns.filter(f => f.checked === true).length;
  }

  exportPivot(exportType: string) {
    setTimeout(() => {
      this.exportReport.emit(exportType);
    }, 10);
  }

  ShowFullScreen() {
    this.isFSRequested = true;
    setTimeout(() => {
      this.showFullScreen.emit(true);
    }, 10);
  }

  RestoreFullScreen() {
    this.isFSRequested = false;
    setTimeout(() => {
      this.showFullScreen.emit(false);
    }, 10);
  }

  showFormula(formula: ValueField) {
    this.selectedValue = formula;
    this.formulaselector.ShowFormula(formula);
  }

  onFSUpdateFormula(fn: MathFunction) {
    this.selectedValue.mathFn = fn;
  }

  onUpdateFormula(fn: Column) {
    if (this.selectedFormulaField === undefined || this.selectedFormulaField === null) {
      if (fn.displayName.trim() === '') {
        fn.displayName = 'Formula #' + (this.formulaFields.length + 1);
      }
      fn.colName = fn.displayName;
      this.formulaFields.push(fn);
    } else {
      let field = this.formulaFields.find(f => f.colName === this.selectedFormulaField.colName);
      if (field !== undefined && field !== null) {
        field = fn;
      }
    }
    delete this.selectedFormulaField;
  }

  onUpdateFormat(e: EventData) {
    this.selectedColumns = e.Columns;
    this.selectedRows = e.Rows;
    this.selectedValues = e.Values;
    setTimeout(() => {
      this.updateFormat.emit(e);
    }, 10);
  }

  ShowFilter() {
    this.showFilter = !this.showFilter;
    if (this.showFilter) {
      this.fcolumns = this.helper.copyArray(this.columns.filter(f => this.selectedColumns.filter(c => c.colName === f.colName).length === 0 && this.selectedRows.filter(c => c.colName === f.colName).length === 0 && this.selectedValues.filter(c => c.column.colName === f.colName).length === 0));
    }
  }

  ShowFormat() {
    this.format.ShowFormat(this.helper.copyArray(this.selectedColumns), this.helper.copyArray(this.selectedRows), this.helper.copyArray(this.selectedValues));
  }

  checkFSelection() {
    this.selectFAll = !this.selectFAll;
    this.fcolumns.forEach(col => {
      col.checked = this.selectFAll;
    });
    if (this.selectFAll) {
      const unselected = this.fcolumns.filter(f => (this.selectedFColumns.filter(fc => fc.colName === f.colName).length === 0));
      unselected.forEach(col => {
        this.selectedFColumns.push(col);
      });
    } else {
      this.selectedFColumns = [];
    }
  }

  onFDropped(col: any) {
    if (this.selectedFColumns && this.selectedFColumns.filter(f => f.colName === col.dragData.colName).length > 0) {
      this.selectedFColumns = this.selectedFColumns.filter(f => f.colName !== col.dragData.colName);
    }
    this.checkFColumnSelected(col.dragData.colName);
  }

  checkFColumnSelected(colName: any) {
    let exists = false;
    if (this.selectedFColumns.filter(f => f.colName === colName).length > 0) {
      exists = true;
    }
    const selectedItem = this.fcolumns.filter(f => f.colName === colName);
    if (selectedItem.length > 0) {
      selectedItem[0].checked = exists;
    }
  }

  onFColDropped(col: any) {
    col.dragData.selected = false;
    if (this.selectedFColumns.filter(f => f.colName === col.dragData.colName).length === 0) {
      this.selectedFColumns.push(col.dragData);
    }
    this.checkFColumnSelected(col.dragData.colName);
  }

  selectFCheck(col: Column) {
    col.checked = !col.checked;
    if (col.checked) {
      this.selectedFColumns.push(col);
    }
    if (!col.checked && this.selectedFColumns.filter(f => f.colName === col.colName).length > 0) {
      this.selectedFColumns = this.selectedFColumns.filter(f => f.colName !== col.colName);
    }
    this.selectFAll = this.fcolumns.filter(f => f.checked).length === this.columns.length;
  }

  cancelFilter() {
    this.showFilter = false;
    this.selectedColumns = this.helper.copyArray(this.selectedColumnsB);
    this.selectedRows = this.helper.copyArray(this.selectedRowsB);
    this.selectedValues = this.helper.copyArray(this.selectedValuesB);
    this.formulaFields = this.helper.copyArray(this.formulaFieldsB);
    this.selectedFColumns = this.helper.copyArray(this.selectedFColumnsB);
    setTimeout(() => {
      this.checkSelectedColumns();
    }, 10);
  }

  ApplyFilter() {
    this.showFilter = false;
    const obj = new EventData();
    obj.Columns = this.selectedColumns;
    obj.Rows = this.selectedRows;
    obj.Values = this.selectedValues;
    obj.Filters = this.selectedFColumns;
    obj.Fields = this.formulaFields;

    this.selectedColumnsB = this.helper.copyArray(this.selectedColumns);
    this.selectedRowsB = this.helper.copyArray(this.selectedRows);
    this.selectedValuesB = this.helper.copyArray(this.selectedValues);
    this.selectedFColumnsB = this.helper.copyArray(this.selectedFColumns);
    this.formulaFieldsB = this.helper.copyArray(this.formulaFields);
    setTimeout(() => {
      this.applyChanges.emit(obj);
    }, 1);
  }

  editFormula(field: Column) {
    this.selectedFormulaField = field;
    this.formula.EditFormula(field);
  }

  AddFField() {
    delete this.selectedFormulaField;
    this.formula.AddFormula();
  }

  SavePivot() {
    if (this.isSaveSubscribed) {
      this.save.ShowSaveOption(this.isCustomSave);
    } else {
      this.save.ShowSaveOption(false);
    }
  }

  onSaveReport(pivotData: PivotSave) {
    setTimeout(() => {
      pivotData.reportType = this.chartType.value;
      this.saveReport.emit(pivotData);
    }, 10);
  }

  onSaveError(err: any) {
    setTimeout(() => {
      this.error.emit(err);
    }, 10);
  }

  onErrorFormula(err: any) {
    setTimeout(() => {
      this.error.emit(err);
    }, 10);
  }
}
